document.addEventListener("ShoptetDOMPageContentLoaded", function () {
  customProduct();
});
document.addEventListener("ShoptetPageSortingChanged", function () {
  customProduct();
});
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
  customProduct();
});
$(document).ready(function () {
  customProduct();
});
document.addEventListener("ShoptetDOMAdvancedOrderLoaded", function () {
  customProduct();
});
function customProduct() {
  $(".product:not(#productsTop .product)").each(function () {
    if ($(this).find(".price-standard").length) {
      var priceSave = $(this).find(".flag-discount .price-save");
      priceSave.text(priceSave.text().replace(/\s+/g, ""));

      $(this).find(".flag-discount").contents().filter(function () {
        return this.nodeType === 3 && this.textContent.trim() === translation('az');
      }).remove();

      $(this).find(".prices").prepend($(this).find(".price-standard"));
    }
  });
}
